import { RefreshCw } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import {
    useKiotVietSyncStatus,
    useTriggerKiotVietSync,
} from '@/hooks/use-customer-query'
import { m } from '@/lib/paraglide/messages'

/**
 * "Đồng bộ KiotViet ngay" button + last-run status. Renders nothing while the
 * integration is disabled (KIOTVIET_SYNC_ENABLED=false) so it stays invisible
 * until the shop provides credentials.
 */
export function KiotVietSyncButton() {
    const { data: status } = useKiotVietSyncStatus()
    const trigger = useTriggerKiotVietSync()

    if (!status?.enabled) return null

    const state = status.state
    const handleSync = () => {
        trigger.mutate(undefined, {
            onSuccess: () => toast.info(m.customer_kiotviet_sync_started()),
            onError: () => toast.error(m.customer_kiotviet_sync_failed()),
        })
    }

    return (
        <div className="flex items-center gap-2">
            {state && state.last_run_at && (
                <span className="text-xs text-muted-foreground">
                    {m.customer_kiotviet_last_sync({
                        imported: state.last_imported,
                        updated: state.last_updated,
                    })}
                </span>
            )}
            <Button
                size="sm"
                variant="outline"
                onClick={handleSync}
                disabled={trigger.isPending}
            >
                <RefreshCw className="size-4" />
                {m.customer_kiotviet_sync_now()}
            </Button>
        </div>
    )
}
